import React from 'react';
import { Link } from 'react-router-dom';

const Privacy = () => {
  return (
    <div style={{
      maxWidth: '720px',
      margin: '0 auto',
      padding: '80px 24px 48px',
      color: 'var(--neutral-100)',
      lineHeight: 1.7,
    }}>
      <h1 style={{ fontSize: '2rem', fontWeight: 700, marginBottom: '8px' }}>Privacy Policy</h1>
      <p style={{ color: 'var(--neutral-400)', fontSize: '0.9rem', marginBottom: '32px' }}>
        Last updated: March 21, 2026
      </p>

      <section style={{ marginBottom: '28px' }}>
        <h2 style={{ fontSize: '1.25rem', fontWeight: 600, marginBottom: '8px' }}>Overview</h2>
        <p style={{ color: 'var(--neutral-300)' }}>
          cnfabian.com is a personal portfolio website and project management tool operated by Christopher Fabian.
          This policy describes how data is collected, used, and protected.
        </p>
      </section>

      <section style={{ marginBottom: '28px' }}>
        <h2 style={{ fontSize: '1.25rem', fontWeight: 600, marginBottom: '8px' }}>Data Collected</h2>
        <ul style={{ color: 'var(--neutral-300)', paddingLeft: '20px' }}>
          <li style={{ marginBottom: '6px' }}>
            <strong>Contact information:</strong> Name and email address submitted through the contact form.
          </li>
          <li style={{ marginBottom: '6px' }}>
            <strong>PM Dashboard data:</strong> Task details, project information, and team activity data entered into the project management tool.
          </li>
          <li style={{ marginBottom: '6px' }}>
            <strong>Google OAuth:</strong> If you authorize Gmail or Google Drive integration for PM functionality,
            we access only the scopes you approve (email sending, Drive document reading). We do not store your Google password.
          </li>
        </ul>
      </section>

      <section style={{ marginBottom: '28px' }}>
        <h2 style={{ fontSize: '1.25rem', fontWeight: 600, marginBottom: '8px' }}>How Data Is Used</h2>
        <p style={{ color: 'var(--neutral-300)' }}>
          Data is used solely to operate the portfolio site and PM Dashboard. It is stored securely and is not
          sold, rented, or shared with third parties.
        </p>
      </section>

      <section style={{ marginBottom: '28px' }}>
        <h2 style={{ fontSize: '1.25rem', fontWeight: 600, marginBottom: '8px' }}>Data Storage & Security</h2>
        <p style={{ color: 'var(--neutral-300)' }}>
          Data is stored on secured servers with access restricted to authorized personnel.
          Authentication tokens are transmitted over HTTPS and stored locally on your device.
        </p>
      </section>

      <section style={{ marginBottom: '28px' }}>
        <h2 style={{ fontSize: '1.25rem', fontWeight: 600, marginBottom: '8px' }}>Contact</h2>
        <p style={{ color: 'var(--neutral-300)' }}>
          For questions about this policy or to request data deletion, contact{' '}
          <a href="mailto:christopher@nestnavigate.com" style={{ color: 'var(--accent-400)' }}>
            christopher@nestnavigate.com
          </a>.
        </p>
      </section>

      <div style={{ marginTop: '40px', paddingTop: '20px', borderTop: '1px solid var(--neutral-800)' }}>
        <Link to="/" style={{ color: 'var(--neutral-400)', fontSize: '0.9rem', textDecoration: 'none' }}>
          &larr; Back to Home
        </Link>
      </div>
    </div>
  );
};

export default Privacy;
